import { Breadcrumbs, Typography } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Link } from "react-router-dom";

const Breadcrumb = ({ currentPage, links = [] }) => {
  return (
    <Breadcrumbs
      separator={<NavigateNextIcon fontSize="small" />}
      aria-label="breadcrumb"
    >
      {/* Home */}
      <Link to="/">Home</Link>

      {/* Dynamic links */}
      {links.map((link, index) => (
        <Link key={index} to={link.path}>
          {link.title}
        </Link>
      ))}

      {/* Current page (not clickable) */}
      <Typography color="text.primary">{currentPage}</Typography>
    </Breadcrumbs>
  );
};

export default Breadcrumb;
